module.exports = __webpack_public_path__ + "static/media/OP_Portal_Arrow_White_RT.4a3851a8.svg";